import React from "react";
import PropTypes from "prop-types";

function InputGroupAddon({ addonType, children, className, ...props }) {
  return (
    <div
      className={`input-group-${addonType} ${className || ""}`.trim()}
      {...props}
    >
      {children}
    </div>
  );
}

InputGroupAddon.propTypes = {
  addonType: PropTypes.oneOf(["append", "prepend"]).isRequired,
  children: PropTypes.node,
  className: PropTypes.string
};

export default InputGroupAddon;
